// extracted by mini-css-extract-plugin
export var close = "b_j";
export var error = "b_g";
export var message = "b_h";
export var notification = "b_b";
export var slideDownBounce = "b_c";
export var success = "b_d";
export var title = "b_f";